import React, { useEffect } from "react";
import { Phone, MessageCircle, Heart, Users, CheckCircle2, Download } from "lucide-react";
import matrimonialImg from "../assets/Media (3).jfif";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/BannerSections.css";

export function MatrimonialBannerSection() {
  const { i18n } = useTranslation();
  const isTa = i18n.language === "ta";
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="banners-section-wrapper" data-aos="fade-up">
      <div className="custom-banner-card" data-aos="zoom-in">
        
        {/* Card Header Row */}
        <div className="custom-card-header">
          <div className="custom-card-title-group">
            <div className="custom-card-icon-box">
              <Users size={24} color="#dc2626" />
            </div>
            <div>
              <h3 className="custom-card-title">
                {isTa ? "ஐஸ்வர்யா திருமண தகவல் மையம்" : "Aishwaryaa Matrimonial"}
              </h3>
              <p className="custom-card-subtitle">
                <Heart size={14} color="#dc2626" fill="#dc2626" />
                <span>{isTa ? "அனைத்து ஜாதி, மதத்தினருக்கும் சிறந்த சேவை" : "Trusted Matrimony Center"}</span>
              </p>
            </div>
          </div>

          
        </div>

        {/* Main Body: CSS Grid (Image Left, Text Right) */}
        <div className="custom-card-body-grid reverse">
          
          {/* LEFT SIDE: Image with Download Option */}
          <div className="custom-image-wrapper" style={{ flexDirection: 'column', gap: '1rem' }}>
            <div className="custom-image-container">
              <img
                src={matrimonialImg}
                alt="Aishwaryaa Matrimonial"
                className="custom-image"
              />
            </div>

            <a 
              href={matrimonialImg} 
              download="Aishwaryaa-Matrimonial.jpg"
              className="custom-btn btn-yellow"
              style={{ width: '100%', maxWidth: '240px', padding: '0.625rem', fontSize: '0.875rem' }}
            >
              <Download size={16} />
              <span>{isTa ? "கார்டை பதிவிறக்கம் செய்ய" : "Download Card"}</span>
            </a>
          </div>

          {/* RIGHT SIDE: Text & Features List */}
          <div className="custom-card-content">
            <h4 className="custom-list-title">
              {isTa ? "சிறப்பு அம்சங்கள்:" : "Key Highlights:"}
            </h4>
            
            <ul className="custom-list">
              <li className="custom-list-item">
                <CheckCircle2 size={16} color="#dc2626" style={{ flexShrink: 0 }} />
                <span>{isTa ? "100% சரிபார்க்கப்பட்ட வரன்கள் & பாதுகாப்பான சேவை" : "100% Verified Profiles & Confidential Service"}</span>
              </li>
              <li className="custom-list-item">
                <CheckCircle2 size={16} color="#d97706" style={{ flexShrink: 0 }} />
                <span>{isTa ? "நேரடி வேத சாஸ்திர ஜோதிட வழிகாட்டுதல்" : "Direct Vedic Astrologer Guidance"}</span>
              </li>
              <li className="custom-list-item">
                <CheckCircle2 size={16} color="#2563eb" style={{ flexShrink: 0 }} />
                <span>{isTa ? "தமிழ்நாடு மற்றும் உலகெங்கிலும் உள்ள வரன்கள்" : "Worldwide Matrimonial Matchmaking"}</span>
              </li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
}
